module.exports = __webpack_public_path__ + "static/media/lifeline_step_7_neg.03d308e9.png";